module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/emxd-charts/bar-horizontal/bar-horizontal.html
// module id = 96
// module chunks = 0